



import React from "react";

const Ourfleets = () => {
 const galleryData = [
  {
    id: 1,
    imgSrc: "/images/gallery/1.jpg",
    title: "Swift Dzire",
    description:
      "Swift Dzire is a compact sedan known for its excellent fuel efficiency, smooth driving experience, and comfortable interior. Ideal for daily city commutes and family outings.",
    link: "/swift-desire",
  },
  {
    id: 3,
    imgSrc: "/images/gallery/7.jpg",
    title: "Honda City",
    description:
      "Honda City offers a premium sedan experience with a refined petrol engine, spacious cabin, and elegant interior. A perfect choice for business travel and luxury city rides.",
    link: "/honda-city",
  },
  {
    id: 2,
    imgSrc: "/images/gallery/8.jpg",
    title: "Hyundai Aura",
    description:
      "Hyundai Aura is a stylish compact sedan with great mileage, refined engine performance, and modern infotainment features. Ideal for corporate travel and airport pickups.",
    link: "/hyundai-aura",
  },
  {
    id: 2,
    imgSrc: "/images/gallery/2.jpg",
    title: "Ertiga",
    description:
      "Ertiga is a stylish and spacious MPV with comfortable seating for seven. Perfect for families and long trips, offering smooth performance and modern features.",
    link: "/ertiga",
  },
  {
    id: 2,
    imgSrc: "/images/gallery/4.jpg",
    title: "Kia Carens",
    description:
      "Kia Carens is a premium 6/7-seater MPV with futuristic design, ventilated seats, and advanced safety features — ideal for luxury family tours and corporate travel.",
    link: "/kia-carens",
  },
  {
    id: 3,
    imgSrc: "/images/gallery/5.jpg",
    title: "Innova Crysta",
    description:
      "Innova Crysta is a premium and powerful MPV renowned for its superior comfort, strong diesel engine, and captain seating options — perfect for long-distance journeys.",
    link: "/innova-crysta",
  },
  {
    id: 2,
    imgSrc: "/images/gallery/6.jpg",
    title: "Innova Hycross",
    description:
      "Innova Hycross combines hybrid efficiency with SUV-style luxury. It offers reclining captain seats, panoramic sunroof, and segment-leading performance.",
    link: "/innova-hycross",
  },
  {
    id: 3,
    imgSrc: "/images/gallery/9.jpg",
    title: "Mercedes E Class",
    description:
      "Mercedes E Class is a luxury sedan with plush interiors, ambient lighting, and chauffeur-class comfort — ideal for VIP travel and corporate executives.",
    link: "/mercedes-eclass",
  },
  {
    id: 2,
    imgSrc: "/images/gallery/10.jpg",
    title: "BMW 5 Series",
    description:
      "BMW 5 Series delivers sporty performance with executive-class luxury. Known for its powerful engine and premium interiors — perfect for high-profile travel.",
    link: "/bmw-5series",
  },
  {
    id: 3,
    imgSrc: "/images/gallery/11.jpg",
    title: "Audi A5",
    description:
      "Audi A5 is a sleek and sporty luxury coupe with premium leather interiors and cutting-edge technology — designed for elite and stylish journeys.",
    link: "/audi-a5",
  },
  {
    id: 2,
    imgSrc: "/images/gallery/12.jpg",
    title: "Toyota Commuter",
    description:
      "Toyota Commuter is a reliable 12-14 seater van ideal for group travel, corporate staff transport, and airport shuttles, offering comfort and ample legroom.",
    link: "/toyota-commuter",
  },
  {
    id: 3,
    imgSrc: "/images/gallery/13.jpg",
    title: "Toyota Vellfire",
    description:
      "Toyota Vellfire is an ultra-luxury MPV with VIP captain seats, ottoman recliners, ambient lighting, and dual sunroofs — the pinnacle of luxury travel.",
    link: "/toyota-vellfire",
  },
  {
    id: 2,
    imgSrc: "/images/gallery/14.jpg",
    title: "Toyota Fortuner",
    description:
      "Toyota Fortuner is a rugged and premium SUV ideal for off-road adventures and long-distance travel — combining power, style, and reliability.",
    link: "/toyota-fortuner",
  },
  {
    id: 2,
    imgSrc: "/images/gallery/15.jpg",
    title: "Urbania 12 Seater",
    description:
      "Urbania 12 Seater is a next-generation premium tempo traveller with high-roof design, reclining seats, and modern AC — perfect for luxury group tours.",
    link: "/urbania-12",
  },
];


  return (
    <>

    <div className="page-header bg-section parallaxie">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="page-header-box">
              <h1 className="text-anime-style-3" data-cursor="-opaque">
                Our Fleets
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>


    
    

      {/* gallery Grid */}
<section
  className="fleet-section section-padding"
  style={{ padding: "70px 0", background: "#f8fbff" }}
>
  <div className="container">
    {/* Header */}
    <div className="text-center mb-5">
     
      <h2 className="fw-bold" style={{ color: "#004aad" }}>
        Our Premium Fleet Collection
      </h2>
      <p style={{ color: "#555", fontSize: "17px" }}>
        Explore our modern, well-maintained vehicles offering comfort, safety, and reliability for every journey.
      </p>
    </div>

    {/* Fleet Grid */}
    <div className="row g-4">
      {galleryData.map((item) => (
        <div key={item.id} className="col-xl-4 col-md-6 col-12">
          <div
            className="fleet-card shadow-lg border-0 rounded-4"
            style={{
              background: "#fff",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              cursor: "pointer",
            }}
          >
            <div
              className="fleet-image position-relative"
              style={{
                overflow: "hidden",
                borderTopLeftRadius: "1rem",
                borderTopRightRadius: "1rem",
              }}
            >
              <img
                src={item.imgSrc}
                alt={item.title}
                className="img-fluid w-100"
                style={{
                  height: "220px",
                  objectFit: "cover",
                  transition: "transform 0.5s ease",
                }}
              />
              <div
                className="fleet-overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                style={{
                  background: "rgba(0,74,173,0.4)",
                  opacity: 0,
                  transition: "opacity 0.3s ease",
                }}
              >
               
              </div>
            </div>

            <div className="fleet-content p-4 text-center">
              <h4 style={{ color: "#004aad", fontWeight: "600" }}>
                {item.title}
              </h4>
              <p
                style={{
                  color: "#444",
                  fontSize: "15px",
                  lineHeight: "1.6",
                  minHeight: "90px",
                }}
              >
                {item.description}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>

    </>
  );
};

export default Ourfleets;
